/**
 * Stops auto-advancing carousels for visitors who prefer reduced motion.
 *
 * The theme's slideshow component pauses on hover, on focus and when the tab is
 * hidden, but it doesn't check prefers-reduced-motion. Autoplay starts in the
 * component's connectedCallback, so we pause it as soon as the element is
 * defined — well inside the first interval, so nothing visibly moves.
 *
 * Pause only: we never call play(), so this can't fight the visitor's own use
 * of the pause button.
 */
(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

  const pauseAutoplayingCarousels = () => {
    if (!reducedMotion.matches) return;

    for (const slideshow of document.querySelectorAll('slideshow-component[autoplay]')) {
      if (typeof slideshow.pause === 'function') slideshow.pause();
    }
  };

  const start = () => {
    pauseAutoplayingCarousels();
    reducedMotion.addEventListener('change', pauseAutoplayingCarousels);
    // Sections re-render in the theme editor and on section reloads.
    document.addEventListener('shopify:section:load', pauseAutoplayingCarousels);
  };

  if (customElements.get('slideshow-component')) {
    start();
  } else {
    customElements.whenDefined('slideshow-component').then(start);
  }
})();
